module.exports = __webpack_public_path__ + "static/media/icon-desktop-outline.c76493a3.svg";